import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".skeleton-wrapper {\n  width: 100%;\n  height: 100%;\n}\n.skeleton-wrapper.button {\n  line-height: 1;\n  display: block;\n}\n.skeleton-wrapper.pill .react-loading-skeleton.react-loading-skeleton {\n  line-height: unset;\n  border-radius: 29px;\n}\n.skeleton-wrapper span {\n  width: 100%;\n  height: 100%;\n}\n.skeleton-wrapper span .react-loading-skeleton.react-loading-skeleton {\n  width: 100%;\n  height: 100%;\n}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=Skeleton.scss.js.map
